import { Box, Button, Typography } from "@mui/material";
import CustomDialog from "../shared/CustomDialog";
import { ReactComponent as Logo } from "../../assets/icons/logo-name.svg";
import ShareIcon from "../../assets/images/iphone-share.png";
import AddIcon from "../../assets/images/add-to-homescreen.png";

export function AddHomeScreenModal(props) {
  const { open, setOpen } = props;

  return (
    <CustomDialog open={open}>
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          minHeight: 264,
        }}
      >
        <Logo width={42} height={78} />
        <Typography align="center" sx={{ mt: 2 }} variant="h4" color="grey.2">
          افزودن وب اپلیکیشن بلوط
        </Typography>
        <Typography
          align="center"
          sx={{ mt: 1 }}
          variant="body2"
          color="grey.4"
        >
          برای تجربه کاربری بهتر، نسخه وب اپلیکیشن رو به صفحه خانه خود اضافه
          کنید.
        </Typography>
        <Typography
          component={"div"}
          sx={{ width: "100%", mt: 2 }}
          variant="body2"
          color="grey.4"
        >
          ۱- دکمه Share{" "}
          <Box display={"inline"}>
            <img
              src={ShareIcon}
              width={24}
              height={24}
              style={{ marginBottom: -6 }}
            />
          </Box>{" "}
          را در نوار پایین کلیک کنید.
        </Typography>
        <Typography
          component={"div"}
          sx={{ width: "100%", mt: 2 }}
          variant="body2"
          color="grey.4"
        >
          ۲- گزینه Add to Home Screen{" "}
          <Box display={"inline"}>
            <img
              src={AddIcon}
              width={24}
              height={24}
              style={{ marginBottom: -6 }}
            />
          </Box>{" "}
          را انتخاب کنید.
        </Typography>
        <Typography
          sx={{ width: "100%", mt: 2 }}
          variant="body2"
          color="grey.4"
        >
          ۳- در قسمت بالا روی Add کلیک کنید.
        </Typography>
        <Button
          onClick={() => {
            localStorage.setItem("add-to-home-screen-visited", "true");
            setOpen(false);
          }}
          sx={{
            mt: 2,
            borderRadius: "12px",
            typography: "h3",
          }}
          variant="outlined"
          fullWidth
        >
          متوجه شدم
        </Button>
      </Box>
    </CustomDialog>
  );
}
